export const PLEASE_SELECT = { value: '', label: __('Please Select...') };
export const PLEASE_SELECT_YEAR = { value: '', label: __('Year') };
export const PLEASE_SELECT_MAKE = { value: '', label: __('Make') };
export const PLEASE_SELECT_MODEL = { value: '', label: __('Model') };
export const PLEASE_SELECT_OPTION = { value: '', label: __('Option') };
